import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { GateEnteryRoute } from "./gate-entry.routes";

export function GateEntery() {
  return (
    <Layout>
      {GateEnteryRoute.subRoutes && (
        <ModuleRouter subRoutes={GateEnteryRoute.subRoutes} path={GateEnteryRoute.path} />
      )}
    </Layout>
  );
}
